import React, {
  useMemo,
  useCallback,
} from 'react';
import {
  selection,
} from 'redux-resource-plugins';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
  WorkoutExercise as WorkoutExerciseType,
} from '@gymcloud/core';

import {
  ID,
} from 'web-utils';

import {
  Button,
  Checkbox,
  EditProperty,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

interface Props {
  workoutId: number
}

const WorkoutExercisesSubHeader = ({
  workoutId,
}: Props) => {
  const mapState = useCallback(state => ({
    visibleSelect: coreSelectors.getWorkoutProperties(
      workoutId,
    )(state).length > 0,
    workoutExercises: coreSelectors.getSortedListWorkoutExercises(
      workoutId,
    )(state) as WorkoutExerciseType[],
    properties: coreSelectors.getWorkoutProperties(
      workoutId,
    )(state),
    defaultProperty: coreSelectors.getDefaultProperty(state),
  }), [workoutId]);

  const {
    properties,
    visibleSelect,
    defaultProperty,
    workoutExercises,
  } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();
  const resourceType = 'exerciseProperties';

  const selectedAll = useMemo(() => workoutExercises.every(e => e.selected), [workoutExercises]);

  const handleAddProperty = () => {
    dispatch(
      coreActions.addResources({
        resourceType,
        resources: [{
          id: ID(),
          isNew: true,
          workout_id: workoutId,
          ...defaultProperty,
        }],
        list: `workout_${workoutId}`,
      }),
    );
  };

  const handleChangeProperty = (propertyId: number, payload: any) => {
    dispatch(
      coreActions.updateResources({
        resourceType,
        resources: [{
          id: propertyId,
          ...payload,
        }],
      }),
    );
  };
  const handleDeleteProperty = (propertyId: number) => {
    dispatch(
      coreActions.deleteResources({
        resourceType,
        resources: [{
          id: propertyId,
        }],
      }),
    );
  };

  const handleAssignProperties = () => {
    dispatch(
      coreActions.requestAssignProperties(
        workoutId,
      ),
    );
  };

  return workoutExercises.length > 1 ? (
    <S.SubHead>
      <Flex align="center" spacing={10}>
        {properties.length ? (
          <Flex align="center" spacing={10}>
            <Flex wrap="wrap">
              {properties.map(item => (
                <EditProperty
                  key={item.id}
                  initialValue={item}
                  onChange={(payload) => {
                    handleChangeProperty(item.id, payload);
                  }}
                  onDelete={() => handleDeleteProperty(item.id)}
                />
              ))}
            </Flex>
            <Button
              ghost
              appearance="primary"
              onClick={handleAssignProperties}
            >
              assign
            </Button>
          </Flex>
        ) : (
          <Text color="#ccc">
            Add metrics to multiple exercises (sets, reps, etc.)
          </Text>
        )}
        <S.Add
          onClick={handleAddProperty}
        >
          <S.PlusCircle />
        </S.Add>

        {visibleSelect && (
          <Checkbox
            id="select_all"
            isBlink
            size="large"
            checked={selectedAll}
            onChange={() => {
              const select = selectedAll ? selection.deselectResources : selection.selectResources;
              dispatch(
                select('workoutExercises', workoutExercises.map(e => e.id)),
              );
            }}
          />
        )}
      </Flex>
    </S.SubHead>
  ) : null;
};

export default WorkoutExercisesSubHeader;
